import React, { useState } from 'react';

import Modal from '@components/common/Modal';

import { IModalSelectOption, IModalSelectProps } from './ModalSelect.types';

import Button from '../Button';
import ModalSelectMenu from './ModalSelectMenu';

const ModalSelect = ({
	label,
	options,
	onChange,
	modalLabel,
	searchPlaceholder,
	searchThreshold,
	values,
	disabled = false,
	isViewMode = false,
	customButton,
}: IModalSelectProps) => {
	const buttonText = values?.length
		? `${label} (${values.length === options.length ? 'all' : values.length})`
		: label;

	const [isSelectMenuOpen, setIsSelectMenuOpen] = useState(false);

	const toggleSelectMenu = () => {
		if (disabled) return;

		setIsSelectMenuOpen((prevState) => !prevState);
	};

	return (
		<div>
			<Modal
				isOpen={isSelectMenuOpen}
				onClose={toggleSelectMenu}
				title={modalLabel || label}
				width='400px'
			>
				<ModalSelectMenu
					isViewMode={isViewMode}
					onChange={onChange}
					options={options as IModalSelectOption[]}
					searchPlaceholder={searchPlaceholder}
					searchThreshold={searchThreshold}
					toggleSelectMenu={toggleSelectMenu}
					values={values}
				/>
			</Modal>
			{customButton ? (
				<div onClick={toggleSelectMenu}>
					{customButton}
				</div>
			) : (
				<Button
					disabled={disabled}
					onClick={toggleSelectMenu}
					secondary
					text={buttonText}
				/>
			)}
		</div>
	);
};

export default ModalSelect;
